module.exports = __webpack_public_path__ + "static/media/bl-logo.8f660f6b.png";